import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { ArrowRight, Handshake } from 'lucide-react';
import type { Page } from '@clawhire/shared';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-client';
import { buttonVariants } from '@/components/ui/button';
import { SettingsCard, SettingsSection } from '@/pages/settings/SettingsSection';

/** Partners are managed on their own pages; this section only points there. */
export function PartnersSettings() {
  const query = { pageSize: 1 };
  const count = useQuery({
    queryKey: queryKeys.list('partners', query),
    queryFn: () => api.get<Page<unknown>>('/partners', { query }),
  });

  return (
    <SettingsSection
      title="Partners"
      description="Intermediaries, suppliers and freelancers are records of their own, with positions, candidates and briefings."
    >
      <SettingsCard>
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-muted text-muted-foreground">
              <Handshake className="h-5 w-5" aria-hidden="true" />
            </span>
            <div>
              <p className="text-sm font-medium">
                {count.data ? `${count.data.total} partner${count.data.total === 1 ? '' : 's'}` : 'Partners'}
              </p>
              <p className="text-sm text-muted-foreground">
                Create partners, keep agreements and contacts up to date, and see who was briefed on which JD.
              </p>
            </div>
          </div>
          <Link to="/partners" className={buttonVariants()}>
            Open partners <ArrowRight aria-hidden="true" />
          </Link>
        </div>
      </SettingsCard>
      <p className="text-xs text-muted-foreground">
        Every intermediary name is added to the forbidden terms automatically, so it never appears in a JD or
        a profile.
      </p>
    </SettingsSection>
  );
}
